import React from 'react'

import {
    Menu,
    Container,
    Dropdown,
    Header,
    Grid,
    Sidebar,
    Icon,
    Image,
    Button,
    Dimmer, Loader, Segment
} from 'semantic-ui-react'
import GridRow from 'semantic-ui-react/dist/commonjs/collections/Grid/GridRow';
var moment = require('moment');
var DateRangePicker = require('react-bootstrap-daterangepicker');



class ReportingBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {


        };
        this.handleReportChange = this.handleReportChange.bind(this);
        // this.handleDateChange = this.handleDateChange.bind(this);
        this.handleLocationChange = this.handleLocationChange.bind(this);
        this.btnSubmit = this.btnSubmit.bind(this);
        this.handleDatePicker = this.handleDatePicker.bind(this);

    }

    handleReportChange = (e, { value }) => {
        // console.log(value, 'value')
        this.props.handleReportChange(value)

    }
    // handleDateChange = (e, { value }) => {
    //     // console.log(value, 'value')
    //     this.props.handleDateChange(value)

    // }
    handleLocationChange = (e, { value }) => {
        // console.log(value, 'value')
        this.props.handleLocationChange(value)

    }
    btnSubmit() {

        this.props.btnSubmit()
    }
    handleDatePicker(event, picker) {
        if (event.type === "hide") {
            if (picker.startDate.format('YYYY-MM-DD') === picker.oldStartDate.format('YYYY-MM-DD') && picker.endDate.format('YYYY-MM-DD') == picker.oldEndDate.format('YYYY-MM-DD'))
                return false;
            this.props.handleDatePicker(picker)

        }
    }
    render() {
        const { reportCurrentValue,
            datePickerEnabled,
            dateCurrentValue,
            locationPickerEnabled,
            locationCurrentValue,
            btnSubmitDisabled,
            reportType,
            reports,
            dates,
            locations,
            submitBtnLoader,
            haveData,
            ranges,
            startDate,
            endDate
        } = this.props;
        const start = startDate.format('YYYY-MM-DD')
        const end = endDate.format('YYYY-MM-DD');
        let label = start + ' - ' + end;
        if (start === end) {
            label = start;
        }
        // console.log("dates : ", dates)
        return (
            <div style={styles.boxMain}>

                <Grid padded={true} columns='equal'>
                    <Grid.Column>
                        <div className="report_dropdown" style={styles.dropdownMain}><p style={styles.text}>Select your report type</p>
                            <div className="report_dropdown_inner" style={styles.dropdownInner}>
                                <Image src='/report_icon.png' style={styles.icon} />
                                <Dropdown
                                    options={reports}
                                    onChange={this.handleReportChange}
                                    value={reportCurrentValue}
                                    search
                                    style={styles.dropdowncont}
                                >
                                </Dropdown>
                            </div>
                        </div>
                    </Grid.Column>


                    <Grid.Column>
                        {/* <div className="report_dropdown" style={styles.dropdownMain}>
                            <p style={styles.text}>Choose date</p>
                            <div className="report_dropdown_inner" style={styles.dropdownInner}>
                                <Image src='/date_icon2.png' style={styles.icon} />
                                <Dropdown
                                    onChange={this.handleDateChange}
                                    search
                                    style={styles.dropdowncont}
                                    options={dates}
                                    disabled={datePickerEnabled}
                                    value={dateCurrentValue}
                                >
                                </Dropdown>
                            </div>
                        </div> */}
                        <div className="report_dropdown" style={styles.dropdownMain}>
                            <p style={styles.text}>Choose date</p>
                            <div className="report_dropdown_inner" style={styles.dropdownInner}>
                                <Image src='/date_icon2.png' style={styles.icon} />
                                {!datePickerEnabled ?
                                    <DateRangePicker
                                        startDate={startDate}
                                        endDate={endDate}
                                        ranges={ranges}
                                        onEvent={this.handleDatePicker}
                                        disabled={datePickerEnabled}>
                                        <span >
                                            {label}
                                            {/* {startDate.format('YYYY-MM-DD')} -  {endDate.format('YYYY-MM-DD')} */}
                                        </span>
                                    </DateRangePicker>
                                    : <div></div>
                                }
                            </div>
                        </div>
                    </Grid.Column>
                    <Grid.Column>
                        <div className="report_dropdown" style={styles.dropdownMain}><p style={styles.text}>Select location</p>
                            <div className="report_dropdown_inner" style={styles.dropdownInner}>
                                <Image src='/location_icon2.png' style={styles.icon} />
                                <Dropdown
                                    onChange={this.handleLocationChange}
                                    style={styles.dropdowncont}
                                    search
                                    options={locations}
                                    disabled={locationPickerEnabled}
                                    value={locationCurrentValue}
                                >
                                </Dropdown>
                            </div>
                        </div>
                    </Grid.Column>
                    <Grid.Column>
                        <Button style={styles.btn} onClick={this.props.btnSubmit} disabled={!haveData}>
                            {submitBtnLoader ? <Loader active inverted inline='centered' style={{ color: 'white', marginTop: -5, }} /> : 'SUBMIT'}
                        </Button>

                    </Grid.Column>
                </Grid>

            </div>
        )
    }

}


const styles = {
    boxMain: {
        minHeight: 100,
        marginBottom: 30,
        marginTop: 10,
        paddingBottom: 20,
        paddingTop: 10,
        backgroundColor: '#ffffff',
        borderRadius: 5,
        boxShadow: '0 1px 6px rgba(0, 0, 0, 0.1)',
    },
    dropdownMain: {
        width: '100%',
        // height: 90,
        float: 'left',
        color: '#999999',
        fontFamily: 'Roboto',
        borderBottom: '1px solid gray'
    },
    dropdownInner: {
        float: 'left',
        width: '100%',
        borderBottomWidth: 0.5,
        // padding: 10,
        marginTop: 10,
    },
    dropdowncont: {
        float: 'left',
        textAlign: 'left',
        width: '80%',
    },
    icon: {
        width: 28,
        height: 33,
        marginRight: 15,
        marginTop: -5,
        display: 'inline',
        float: 'left',

    },
    text: {
        fontSize: 18,
        fontWeight: 100,
        float: 'left'
    },
    btn: {
        marginTop: 35,
        color: 'white',
        backgroundColor: '#9989E0',
        fontFamily: 'Roboto',
        fontWeight: 300,
        height: 50,
        width: '100%'
    }
}

export default ReportingBox;



// WEBPACK FOOTER //
// ./src/components/ReportingBox/index.js